import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { CreateFeedAdviceComponent } from './components/create-feed-advice/create-feed-advice.component';
import { CreateFeedAdviceFromReferenceComponent } from './components/create-feed-advice-from-reference/create-feed-advice-from-reference.component';
import { FeedAdviceOverviewComponent } from './components/feed-advice-overview/feed-advice-overview.component';
import { FeedAdviceRouterComponent } from './components/feed-advice-router/feed-advice-router.component';
import { FeedAdviceOverviewResolver } from './resolvers/feed-advice-overview.resolver';
import { GetFeedAdviceByIdResolver } from './resolvers/get-feed-advice-by-id.resolver';

const feedAdviceFeatureRoutes: Routes = [
  {
    path: '',
    component: FeedAdviceOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'create-from-reference',
    component: CreateFeedAdviceFromReferenceComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'create',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      data: mapToResolve(FeedAdviceOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      feedadvice: mapToResolve(GetFeedAdviceByIdResolver),
    },
  },
  {
    path: 'view/:id',
    component: CreateFeedAdviceComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      feedadvice: mapToResolve(GetFeedAdviceByIdResolver),
    },
  },
];

export const feedAdviceRoutes: Routes = [
  {
    path: 'feed-advice',
    component: FeedAdviceRouterComponent,
    children: feedAdviceFeatureRoutes,
  },
];
